// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"73949db1","453":"c1e80ae5","667":"92d8dff8"}[chunkId] + ".chunk.js";
};